import {DOT_PATTERN_BOUNDS,DOT_TILE_SIZE,normalizeDotPattern,dotPatternTile,patternDotPoints} from './dot-pattern.js';

export default function DotPattern({layer,prefix}) {
  const id=`${prefix}dots${layer.id}`,clipId=`${id}bounds`,state=normalizeDotPattern(layer),bounds=DOT_PATTERN_BOUNDS;
  const erased=state.erasedDots.length>0||Boolean(state.dotSizes);
  // Draw surviving geometry once. Subtracting an antialiased mask from an
  // antialiased dot leaves a coloured fringe, especially on small previews.
  // One path avoids thousands of DOM nodes on dense ten-finger designs.
  const survivingPath=erased?patternDotPoints(layer).map(({x,y,r})=>`M${x-r} ${y}a${r} ${r} 0 1 0 ${r*2} 0a${r} ${r} 0 1 0 ${-r*2} 0Z`).join(''):'';
  const tileCoordinates=(center,radius)=>[-DOT_TILE_SIZE,0,DOT_TILE_SIZE].map(offset=>center+offset).filter(value=>value+radius>0&&value-radius<DOT_TILE_SIZE);
  return <g data-dot-density={state.dotDensity} data-dot-size={state.dotSize} transform={state.dotFlipX?'translate(100 0) scale(-1 1)':undefined}>
    <defs>
      {!erased&&<pattern id={id} width={DOT_TILE_SIZE} height={DOT_TILE_SIZE} patternUnits="userSpaceOnUse">
        {dotPatternTile(state.dotDensity,state.dotSize).flatMap((dot,index)=>tileCoordinates(dot.x,dot.r).flatMap(x=>tileCoordinates(dot.y,dot.r).map(y=><circle key={`${index}:${x}:${y}`} cx={x} cy={y} r={dot.r} fill={layer.color}/>)))}
      </pattern>}
      {erased&&<clipPath id={clipId} clipPathUnits="userSpaceOnUse"><rect {...bounds}/></clipPath>}
    </defs>
    {erased?<g clipPath={`url(#${clipId})`}>
      <rect {...bounds} fill="transparent" pointerEvents="all"/>
      <path d={survivingPath} fill={layer.color} fillRule="nonzero" pointerEvents="none"/>
    </g>:<rect {...bounds} fill={`url(#${id})`}/>}
  </g>;
}
